'use client';
import e from 'prop-types';
import { createContext, useContext } from 'react';
import { SwanPathTypeEnum } from '../../../core/types/enums.js';
import { SWAN_BASE_CDN_URL } from '../../../core/constants/domains.js';

const swanLoaderConfigProps = {
    swanBaseUrl: e.string,
    swanTenant: e.string,
    swanLocale: e.string,
    swanPathType: e.oneOf([
        SwanPathTypeEnum.hashed,
        SwanPathTypeEnum.versioned
    ])
};
let r = {
    swanBaseUrl: SWAN_BASE_CDN_URL,
    swanPathType: SwanPathTypeEnum.hashed
};
const SwanContext = createContext(r);
SwanContext.displayName = 'SwanContext';
function useSwanContext() {
    return useContext(SwanContext);
}

export { SwanContext, swanLoaderConfigProps, useSwanContext };
